module.exports = __webpack_public_path__ + "img/kma_gallery13.f72d02cd.jpg";